var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4167,
    cy: 16.2916,
    rx: 9.91667,
    ry: 9.20833,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 2.83325C9.18817 2.83325 2.83301 9.18842 2.83301 16.9999C2.83301 24.8114 9.18817 31.1666 16.9997 31.1666C24.8112 31.1666 31.1663 24.8114 31.1663 16.9999C31.1663 9.18842 24.8112 2.83325 16.9997 2.83325ZM16.9997 8.49992C19.408 8.49992 21.2497 10.3416 21.2497 12.7499V14.1666C22.0997 14.1666 22.6663 14.7333 22.6663 15.5833V21.2499C22.6663 22.0999 22.0997 22.6666 21.2497 22.6666H12.7497C11.8997 22.6666 11.333 22.0999 11.333 21.2499V15.5833C11.333 14.7333 11.8997 14.1666 12.7497 14.1666V12.7499C12.7497 10.3416 14.5913 8.49992 16.9997 8.49992ZM16.9997 10.6249C15.8663 10.6249 14.8747 11.6166 14.8747 12.7499V14.1666H16.9997H19.1247V12.7499C19.1247 11.6166 18.133 10.6249 16.9997 10.6249ZM16.9997 16.9999C16.624 16.9999 16.2636 17.1492 15.9979 17.4149C15.7323 17.6805 15.583 18.0409 15.583 18.4166C15.583 18.7923 15.7323 19.1526 15.9979 19.4183C16.2636 19.684 16.624 19.8333 16.9997 19.8333C17.3754 19.8333 17.7357 19.684 18.0014 19.4183C18.2671 19.1526 18.4163 18.7923 18.4163 18.4166C18.4163 18.0409 18.2671 17.6805 18.0014 17.4149C17.7357 17.1492 17.3754 16.9999 16.9997 16.9999Z",
    fill: "#E8361E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.16a071ad0f651ca1e724b3ce5625b60c.svg";
export { ForwardRef as ReactComponent };